import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { fetchDocumentTypes } from '../../../store/slices/forms';
import { attachmentContractColumns } from '../table-configs/columns-schemas';
import AddButton from './AddButton';
import DefaultTable from './DefaultTable';
import requestEndpoints from '../../../api/services/requestEndpoints';
import { STATUS_CODES } from '../../../config/status';
import notification from '../../../config/notification';
import { v4 as uuid } from 'uuid';

const DEFAULT_ATTACHMENT = {
  nuAnexoContrato: '',
  nuSolicitacaoFmt: '',
  canEdit: false,
  lockSelect: false,
  arquivo: '',
  idFile: '',
  deDescricao: '',
  fileName: '',
  tipoDocumento: null,
  error: {
    nuAnexoContrato: '',
    tipoDocumento: '',
  },
};

const ContractDocuments = props => {
  const dispatch = useDispatch();
  const { classes, documents, setDocuments, deletedDocuments, setDeletedDocuments, selectedContract, onOpenRequestDrawer } = props;
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [uploadingDocument, setUploadingDocument] = useState(false);

  const [rows, setRows] = useState([]);

  const documentTypes = useSelector(state => state.forms.documentTypes);

  const prepareRow = (docs) => {
    return docs.map(doc => {
      const temp = { ...doc };
      if(!temp.nuSolicitacaoFmt){
        temp.nuSolicitacaoFmt = temp.solicitacao?.nuSolicitacaoFmt;
      }
      return temp;
    });
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const promisses = [];
      if (documentTypes.length === 0) promisses.push(dispatch(fetchDocumentTypes()));
      if (promisses.length > 0) await Promise.all(promisses);
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      setRows(prepareRow(documents));
      setLoading(false);
    })();
  }, [documents]);

  const deleteElementFromDocuments = (entry) => {
    setDeleting(true);
    let temp = [...documents];
    let tempRowsDeleted = [...deletedDocuments];
    let entryIndex = entry.index;
    if (entryIndex !== undefined) {
      if(temp[entryIndex].cdContratoTermoAditivo){
        tempRowsDeleted.push({...temp[entryIndex], boExcluido: true});
      }
      temp.splice(entryIndex, 1);
    }
    setDocuments(temp);
    setDeletedDocuments(tempRowsDeleted);
    setDeleting(false);
  };

  const handleAddNewRow = () => {
    const temp = [...documents, DEFAULT_ATTACHMENT];
    setDocuments(temp.map(doc => {
      return { id: uuid(), ...doc }
    }));
  }

  return (
    <Grid item xs={12}>
      {!deleting && (
        <DefaultTable
          loading={loading}
          title='Anexos'
          columns={attachmentContractColumns}
          rows={rows}
          rowVerticalAlign={'top'}
          buttonsCellStyle={{ verticalAlign: 'middle' }}
          onDelete={(e, data, index) => {
            deleteElementFromDocuments({ e, data, index });
          }}
          entryProps={{
            variant: 'outlined',
            margin: 'dense',
            uploadingState: uploadingDocument,
            idProperty: 'cdContratoTermoAditivo',
            idValue: selectedContract?.cdContratoTermoAditivo,
            setUploadingState: setUploadingDocument,
            inputProps: {
              nuAnexoContrato: { maxLength: 10 },
            },
            documentList: documentTypes,
            setOpenRequestDrawer: ({open, index}) => onOpenRequestDrawer({open, index}),
            onBlurRequest: async ({ value, index }) => {
              if(!value || value === '') return;
              const response = await requestEndpoints.getRequests({ txtBusca: value, page: 0 }, '');
              if (response?.status === 200 && response.data) {
                const requests = response.data.content;

                const noRequest = requests.length === 0;
                const invalidRequest = !noRequest && (requests[0].cdSituacao === STATUS_CODES.CANCELADO || requests[0].cdSituacao === STATUS_CODES.APROVADO);

                let cdSolicitacao = null;
                let nuSolicitacaoFmt = null;
                let error = { ...documents[index].errors };

                if (!noRequest && !invalidRequest) {
                  cdSolicitacao = requests[0].cdSolicitacao;
                  nuSolicitacaoFmt = value;
                } else {
                  const msg = invalidRequest ? `A solicitação ${value} está cancelada ou aprovada` : `Solicitação ${value} não encontrada`;
                  notification(msg, {
                    toastId: 'VALIDATION',
                    type: 'error',
                  });
                  error.nuSolicitacaoFmt = 'Campo incorreto';
                }

                setDocuments(prevDocs => {
                  let temp = [...prevDocs];
                  temp[index] = { ...temp[index], cdSolicitacao, nuSolicitacaoFmt, error };
                  return temp;
                });
              }
            },
            onChangeTextField: ({ name, value, index }) => {
              setDocuments(prevDocs => {
                let temp = [...prevDocs];
                temp[index] = { ...temp[index], [name]: value };
                if(name === "nuSolicitacaoFmt" && value === "") {
                  temp[index].solicitacao = null;
                  temp[index].cdSolicitacao = null;
                }
                return temp;
              });
            },
            onSelectDocType: (newDocObj, index) => {
              const document = documents[index];
              const cdTipoDocumento = newDocObj.cdTipoDocumento;
              if (cdTipoDocumento) {
                let tipoDocumento = newDocObj;
                const found = documents.filter((doc, i) => {
                  if (i === index) return false;
                  return document.cdSolicitacao === doc.cdSolicitacao && doc.tipoDocumento?.cdTipoDocumento === cdTipoDocumento;
                }).length > 0;
                if (found) {
                  notification(`Este tipo de documento para esta solicitação já encontra-se na listagem`, {
                    toastId: 'VALIDATION',
                    type: 'error',
                  });
                  tipoDocumento = null;
                }
                setDocuments(prevDocs => {
                  let temp = [...prevDocs];
                  temp[index] = {
                    ...temp[index],
                    tipoDocumento,
                    boAlterado: true,
                    canEdit: Boolean(tipoDocumento),
                  };
                  return temp;
                });

              }
            },
            onDeleteFile: (docId, index) => {
              setDocuments(prevDocs => {
                let temp = [...prevDocs];
                temp[index] = {
                  ...temp[index],
                  idFile: docId,
                  boAlterado: true,
                  lockSelect: false,
                };
                return temp;
              });
            },
            onSelectFile: (data, index) => {
              setDocuments(prevDocs => {
                let temp = [...prevDocs];
                temp[index] = { ...temp[index], ...data };
                return temp;
              });
            },
          }}
          actionButton={
            <AddButton
              className={classes.addButton}
              disabled={loading}
              onClick={() => handleAddNewRow()}
            >
              Adicionar
            </AddButton>
          }
        />
      )}
    </Grid>
  );
};

export default ContractDocuments;